// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartLinePromoLabelStyles } from "@guestsupply/App/Components/Cart/CartLinePromoLabel";
import SuccessAlert from "@guestsupply/XDL/Icons/SuccessAlert";
import { css } from "styled-components";

cartLinePromoLabelStyles.wrapper = {
    css: css`
        display: flex;
        align-items: center;
        gap: 12px;
    `,
};

cartLinePromoLabelStyles.promoIcon = {
    src: SuccessAlert,
    color: "success.main",
    size: 12,
};

cartLinePromoLabelStyles.promotionNameText = {
    size: 12,
    lineHeight: "14px",
    weight: "bold",
};
